export enum LicenceTypeCode {
    normal = "normal",
    test = "test",
    crac = "crac"
}
